
        <div class="topbar clearfix">
            <div class="topbar-left">
                <div class="logo" routerLink="/" style="cursor: pointer"></div>
            </div>

            <div style="float: right; top: 20px; position: relative; font-size: 25px; right: 25px;">
              <span class="logged-user">{{session.user?.lastName}} {{session.user?.firstName}} ({{ session.mainRole }})</span>
              <a href="#" (click)="logout()"><i class="material-icons">power_settings_new</i></a>
            </div>

            <div class="topbar-right">
            </div>
        </div>
    